export const VMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="4" fill="#24C45A" />
    <path
      d="M8 8 L24 40 L40 8 L31.5 8 L24 24.5 L16.5 8 Z"
      fill="#080B09"
    />
    <path d="M24 24.5 L27 18 L24 8.5 L21 18 Z" fill="#080B09" opacity="0.35" />
  </svg>
);

export const Logo = ({ stacked = false }) => (
  <span className="flex items-center gap-3" data-testid="site-logo">
    <VMark className={stacked ? "h-11 w-11" : "h-9 w-9"} />
    <span className="leading-none">
      <span
        className={`block font-heading font-black tracking-tight text-white ${
          stacked ? "text-2xl" : "text-lg"
        }`}
      >
        VELOCITY
      </span>
      <span
        className={`block font-heading font-bold tracking-[0.28em] text-ves-green ${
          stacked ? "text-[11px]" : "text-[9px]"
        }`}
      >
        ELECTRICAL SURPLUS
      </span>
    </span>
  </span>
);
